import { useFormContext } from "react-hook-form";
import { FormControl, Input, InputLabel, TextField } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const Index = (props: any) => {
  const { register, setValue, getValues, watch } = useFormContext();
  const watchFields = watch("datumRegistracije");
  const datumRegistracije = getValues("datumRegistracije");
  const [open, setOpen] = useState(false);

  return (
    <>
      <FormControl fullWidth error={!daLiJePoljeValidno("datumRegistracije")}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className={"customDatePickerWidth"}>
            <DatePicker
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              label="*Datum ulaska u status operatera platforme koji izvješćuje (Commencement date of reporting platform operator)"
              format={"DD/MM/YYYY"}
              value={datumRegistracije}
              slotProps={{
                textField: {
                  variant: "standard",
                  fullWidth: true,
                  error: !daLiJePoljeValidno("datumRegistracije"),
                  onClick: () => setOpen(true),
                },
              }}
              onChange={(noviDatum) => {
                setValue(
                  "datumRegistracije",
                  dayjs(noviDatum).format("YYYY-MM-DD")
                );
                setValue(
                  "izvjestajnaGodina",
                  `${dayjs(noviDatum).get("year")}-12-31`
                );
              }}
            />
          </div>
        </LocalizationProvider>
      </FormControl>
      <Input
        type={"hidden"}
        value={
          datumRegistracije ? dayjs(datumRegistracije).format("YYYY-MM-DD") : ""
        }
        data-testid={"datumRegistracije"}
        {...register("datumRegistracije")}
      />
      <Input
        type={"hidden"}
        value={
          datumRegistracije
            ? `${dayjs(datumRegistracije).get("year")}-12-31`
            : ""
        }
        {...register("izvjestajnaGodina")}
      />
      <PorukaGreskePolja nazivPolja={"datumRegistracije"} />
    </>
  );
};

export default Index;
